// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import about from './routes/about';
import micrositeAlejandria from './routes/micrositeAlejandria';
import micrositeBnt from './routes/micrositeBNT';
import press from './routes/press';

const WOW = require('wowjs');

window.wow = new WOW.WOW();
window.wow.init();

document.addEventListener('DOMContentLoaded', function load() {
  if (!window.jQuery) return setTimeout(load, 50);
  const jQuery = require("jquery");
  /** Populate Router instance with DOM routes */
  const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About page
    about,
    // Alejandria microsite
    micrositeAlejandria,
    // BTN microsite
    micrositeBnt,
    press
  });

  // Load Events

  jQuery($ => {
    routes.loadEvents($)
    $.migrateMute = true;
    $.migrateTrace = false;
  });
});


